import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CreateTurnkeyCostData, TurnkeyCostData} from "../../types/tp-turnkey-cost-modal,types";
import {defaultTurnkeyCostData} from "../../configs/default-turnkey-cost-data";
import {UtilityService} from "../../../../../../../../core/services/utility.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {TpTurnkeyCostService} from "../../services/tp-turnkey-cost.service";
import {turnkeyCostFields} from "../../configs/turnkey-cost-fields";
import {TpTurnkeyCostPathStateService} from "../../services/tp-turnkey-cost-path-state.service";
import {MatButton} from "@angular/material/button";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {DateInputDirective} from "../../../../../../../../shared/directives/date-input.directive";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";

@Component({
  selector: 'app-turnkey-cost-form',
  standalone: true,
  imports: [
    MatButton,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatDatepicker,
    MatDatepickerToggle,
    MatDatepickerInput,
    MatSuffix,
    DateInputDirective,
    CdkTextareaAutosize
  ],
  templateUrl: './turnkey-cost-form.component.html',
  styleUrls: [
    '../../tp-turnkey-cost-modal.component.scss',
    './turnkey-cost-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TurnkeyCostFormComponent {
  parentId = input<number>(0);
  turnkeyCostFormGroup = input<FormGroup>(new FormGroup({}));
  turnkeyCostData = input<TurnkeyCostData>(defaultTurnkeyCostData);
  isEditModeActive = input<boolean>(false);
  noFirstData = input<boolean>(false);
  updateTurnkeyCostData = output<TurnkeyCostData>();
  deleteTurnkeyCost = output<void>();

  private tpTurnkeyCostService: TpTurnkeyCostService = inject(TpTurnkeyCostService);
  private tpTurnkeyCostPathStateService: TpTurnkeyCostPathStateService = inject(TpTurnkeyCostPathStateService);
  private utilityService: UtilityService = inject(UtilityService);

  public readonly turnkeyCostFields = turnkeyCostFields;

  public getFieldClass(): string {
    if (!this.turnkeyCostData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.turnkeyCostData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: this.tpTurnkeyCostPathStateService.pathState(),
      recordId: this.turnkeyCostData().id,
      fieldName: key,
      value: this.getValue(key)
    };

    const data = await this.tpTurnkeyCostService.updatedRecordField<TurnkeyCostData>(params)
      .catch(() => this.turnkeyCostData());
    this.updateTurnkeyCostData.emit(data);
  }

  public handelDelete(): void {
    this.deleteTurnkeyCost.emit();
  }

  public async handelCreate(): Promise<void> {
    const createTurnkeyCostData: CreateTurnkeyCostData = {
      technicalParametersId: this.parentId(),
      ...this.turnkeyCostFormGroup().value
    };

    const data = await this.tpTurnkeyCostService.createTurnkeyCost(createTurnkeyCostData).catch(() => defaultTurnkeyCostData);
    this.updateTurnkeyCostData.emit(data);
  }

  private getValue(key: string): string {
    const value = this.turnkeyCostFormGroup().get(key)?.value;
    return value instanceof Date ? this.utilityService.formatDateForApi(value) : value;
  }
}
